export default __webpack_public_path__ + "static/media/image-hero.b66d2053.jpg";